import React, { useContext, useState } from 'react';
import useAuthentication from './onAuthStateChange';

const AuthContext = React.createContext();

export function AuthProvider({ children }) {
  const {user: currentUser} = useAuthentication()
  const [timeActive, setTimeActive] = useState(false);
  return (
    <AuthContext.Provider value={{ currentUser, timeActive, setTimeActive }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthValue() {
  return useContext(AuthContext);
}
